//  ScheduledReplenishment.aspx
var ScheduledReplenishment = (function(backOffice, $) {

    backOffice.ScheduledReplenishment = (function() {
		var scopeSelector = backOffice.options.scopeSelector;

		var registerEvents = function() {
				$(".btn-view-settings-info", scopeSelector).on("click", function() {
					hideError();
					var schedulSettingsSection = $("#scheduleSetting", scopeSelector);
					var parameterSettingsSection = $(
						"#ParameterContainer",
						scopeSelector
					);

					if (!backOffice.ScheduledReplenishment.ValidateScheduleForm()) {
						return false;
					}

					schedulSettingsSection.addClass("hidden");
					parameterSettingsSection.removeClass("hidden");
				});

				$(".btn-view-schedule-info", scopeSelector).on("click", function() {
					var schedulSettingsSection = $("#scheduleSetting", scopeSelector);
					var parameterSettingsSection = $(
						"#ParameterContainer",
						scopeSelector
					);

					schedulSettingsSection.removeClass("hidden");
					parameterSettingsSection.addClass("hidden");
				});

				$(".salesOnlyCheckBox input", scopeSelector).on(
					"change",
					function toggleSalesOnly(e) {
						//  Sales Formula should never turn off mandatory sales period
						let formulaName = $("#txtFormulaName").val();
						if (formulaName != "Sales Formula") {
							handleSalesOnlySelection($(this).is(":checked"));
						}
					}
				);
			},
			pageOnLoad = function() {
				handleSalesOnlySelection(
					$(".salesOnlyCheckBox input", scopeSelector).is(":checked")
				);
			},
			validateWeeks = function(numberPicker, isExit) {
				if (numberPicker.value !== "") {
					if (parseInt(numberPicker.value) < parseInt(numberPicker.min)) {
						numberPicker.value = numberPicker.min;
					}
					if (parseInt(numberPicker.value) > parseInt(numberPicker.max)) {
						numberPicker.value = numberPicker.max;
					}
				} else {
					if (isExit) {
						numberPicker.value = numberPicker.min;
					}
				}
			},
			initialise = function(options) {
				$.extend(backOffice.options, options);
				pageOnLoad();
				registerEvents();
			},
			validateSettingsForm = function() {
				let salesPeriodFixedDateRange =
						BackOffice.options.salesDatePickerControlIds
							.salesPeriodFixedDateRange,
					salesPeriodDuration =
						BackOffice.options.salesDatePickerControlIds.salesPeriodDuration,
					salesPeriodDurationValue =
						BackOffice.options.salesDatePickerControlIds
							.salesPeriodDurationValue,
					salesFromDatePicker =
						BackOffice.options.salesDatePickerControlIds.salesFromDatePicker,
					salesToDatePicker =
						BackOffice.options.salesDatePickerControlIds.salesToDatePicker,
					runratePeriod =
						BackOffice.options.salesDatePickerControlIds.runratePeriod,
					outletFrom = BackOffice.options.salesDatePickerControlIds.outletFrom,
					outletTo = BackOffice.options.salesDatePickerControlIds.outletTo,
					salesOnly = BackOffice.options.salesDatePickerControlIds.salesOnly,
					salesDateRangeCell =
						BackOffice.options.salesDatePickerControlIds.salesDateRange,
					formulaName = $("#txtFormulaName").val(),
					isValid = true,
                    fromPicker =
                        BackOffice.options.periodDatePickerControlIds.fromDatePicker,
                    toPicker =
                        BackOffice.options.periodDatePickerControlIds.toDatePicker,
                    periodDuration =
                        BackOffice.options.periodDatePickerControlIds.periodDuration,
                    periodDurationValue =
                        BackOffice.options.periodDatePickerControlIds
                            .periodDurationValue,
                    dateRangeCell =
                        BackOffice.options.periodDatePickerControlIds.dateRange,
                    periodFixedDateRange =
                    BackOffice.options.periodDatePickerControlIds.periodFixedDateRange;

				if (formulaName == "Sales Formula") {
					// sales period mandatory
					if (salesPeriodDuration.is(":checked")) {
						//  disregard datepickers because duration is selected
						if (salesPeriodDurationValue.val() == "") {
							BackOffice.FieldValidationIsFailing(salesPeriodDuration, true);
							isValid = false;
						}
					} else {
						//  date range selector must be selected
						salesFromDatePicker.trigger("change");
						if (salesFromDatePicker.val() == "") {
							isValid = false;
						}

                    salesToDatePicker.trigger("change");
                    if (salesToDatePicker.val() == "") {
                        isValid = false;
                    }
                }

            } else if (formulaName == "Run Rate Formula" || formulaName == "Depleted Stock Formula") {

                if (periodDuration.is(":checked") && periodDurationValue.val() == "") {
                    BackOffice.FieldValidationIsFailing(dateRangeCell, true);
                    showPeriodValidationTooltip(true);
                    isValid = false;
                }

                if (periodFixedDateRange.is(":checked")){

                    if (fromPicker.val() == "") {
                        fromPicker.trigger("change");
                        isValid = false;
                    }

                    if (toPicker.val() == "") {
                        toPicker.trigger("change");
                        isValid = false;
                    }

                }

                //  sales period mandatory only if product with sales only checked
                if (salesOnly.is(":checked")) {

                    if (salesPeriodDuration.is(":checked") && salesPeriodDurationValue.val() == "") {
                        BackOffice.FieldValidationIsFailing(salesDateRangeCell, true);
                        showSalesPeriodValidationTooltip(true);
                        isValid = false;
                    }

                    if (salesPeriodFixedDateRange.is(":checked")){

                        if (salesFromDatePicker.val() == "") {
                            salesFromDatePicker.trigger("change");
                            isValid = false;
                        }

                        if (salesToDatePicker.val() == "") {
                            salesToDatePicker.trigger("change");
                            isValid = false;
                        }

                    }
                }

            } else if (formulaName == "MSL Formula") {

                //  sales period mandatory only if product with sales only checked
                if (salesOnly.is(":checked")) {

                    if (salesPeriodDuration.is(":checked") && salesPeriodDurationValue.val() == "") {
                        BackOffice.FieldValidationIsFailing(salesDateRangeCell, true);
                        showSalesPeriodValidationTooltip(true);
                        isValid = false;
                    }

                    if (salesPeriodFixedDateRange.is(":checked")){

                        if (salesFromDatePicker.val() == "") {
                            salesFromDatePicker.trigger("change");
                            isValid = false;
                        }

                        if (salesToDatePicker.val() == "") {
                            salesToDatePicker.trigger("change");
                            isValid = false;
                        }
                    }
                }
            }

				if (!outletFrom.val()) {
					BackOffice.FieldValidationIsFailing(outletFrom, true);
					isValid = false;
				} else {
					BackOffice.FieldValidationIsFailing(outletFrom, false);
				}

				if (!outletTo.val()) {
					BackOffice.FieldValidationIsFailing(outletTo, true);
					isValid = false;
				} else {
					BackOffice.FieldValidationIsFailing(outletTo, false);
				}

				BackOffice.ToggleLoader(isValid);
				return isValid;
			},
			validateScheduleTime = function(sender, eventArgs) {
				let $scheduleTime = $(sender.get_element());

				if (!sender.get_selectedDate()) {
					BackOffice.FieldValidationIsFailing($scheduleTime, true);
					return false;
				} else {
					BackOffice.FieldValidationIsFailing($scheduleTime, false);
				}

				return true;
			},
			// Called when the last date changes, ensuring that it
			// cannot be before the first date
			validateLastDate = function() {
				let $firstDate =
						BackOffice.options.salesDatePickerControlIds.firstDateObject,
					$lastDate =
						BackOffice.options.salesDatePickerControlIds.lastDateObject,
					firstDateObject = $find($firstDate.attr("id")),
					firstDateSelected = firstDateObject.get_selectedDate(),
					lastDateObject = $find($lastDate.attr("id")),
					lastDateSelected = lastDateObject.get_selectedDate();

				if (!lastDateSelected) {
					BackOffice.FieldValidationIsFailing($lastDate, true);
					return false;
				} else {
					BackOffice.FieldValidationIsFailing($lastDate, false);
				}

				if (firstDateSelected > lastDateSelected) {
					lastDateObject.set_selectedDate(firstDateSelected);
				}

				return true;
			},
			// Called when the first date changes, ensuring that the last
			// date cannot be before it
			validateFirstDate = function() {
				let $firstDate =
						BackOffice.options.salesDatePickerControlIds.firstDateObject,
					$lastDate =
						BackOffice.options.salesDatePickerControlIds.lastDateObject,
					firstDateObject = $find($firstDate.attr("id")),
					firstDateSelected = firstDateObject.get_selectedDate(),
					lastDateObject = $find($lastDate.attr("id")),
					lastDateSelected = lastDateObject.get_selectedDate();

				if (!firstDateSelected) {
					BackOffice.FieldValidationIsFailing($firstDate, true);
					return false;
				} else {
					BackOffice.FieldValidationIsFailing($firstDate, false);
				}

				if (firstDateSelected > lastDateSelected) {
					lastDateObject.set_selectedDate(firstDateSelected);
				}

				// Don't allow any date before the first date to be picked
				lastDateObject.set_minDate(firstDateSelected);
				return true;
			},
			validateScheduleForm = function() {
				let $executionTime = $("#executionTime", scopeSelector),
					$scheduleName = $("#scheduleName", scopeSelector),
					isValid = true;

				if (!$executionTime.val()) {
					BackOffice.FieldValidationIsFailing($executionTime, true);
					isValid = false;
				}

				if (!$scheduleName.val()) {
					BackOffice.FieldValidationIsFailing($scheduleName, true);
					isValid = false;
				}

				// Check that at least one day has been selected
				let checkboxes = document.querySelectorAll('input[type="checkbox"]'),
					checkedOne = Array.prototype.slice
						.call(checkboxes)
						.some(chkbox => chkbox.checked);

				if (!checkedOne) {
					showError("You must select at least one day of the week.");
					isValid = false;
				}

				return validateFirstDate() && validateLastDate() && isValid;
			},
			showError = function(errorText) {
				document.getElementById("ErrorBarOuterDiv").style.display = "block";
				document
					.getElementById("ErrorBarInnerDiv")
					.classList.add("notification-bg-info");
				document
					.getElementById("ErrorBarInnerDiv")
					.classList.remove("notification-bg-success");
				document.getElementById("ErrorBarLi").innerHTML = errorText;
			},
			hideError = function() {
				document.getElementById("ErrorBarOuterDiv").style.display = "none";
			},
			handleSalesOnlySelection = function(isEnabled) {
				let formulaName = $("#txtFormulaName").val();

				if (formulaName != "Sales Formula") {
					//  sales formula always requires that sale period is mandatory
					if (isEnabled) {
						$(".salesPeriodPickers", scopeSelector).addClass("IsRequired");
						return true;
					}

					$(".salesPeriodPickers", scopeSelector).removeClass("IsRequired");
					showSalesPeriodValidationTooltip(false);
					return true;
				}
			},
			validateSalesPeriodPicker = function(s, args) {
				var salesFromPicker =
						BackOffice.options.salesDatePickerControlIds.salesFromDatePicker,
					salesToPicker =
						BackOffice.options.salesDatePickerControlIds.salesToDatePicker,
					salesPeriodDuration =
						BackOffice.options.salesDatePickerControlIds.salesPeriodDuration,
					salesPeriodDurationValue =
						BackOffice.options.salesDatePickerControlIds
							.salesPeriodDurationValue,
					durationIsSelected = salesPeriodDuration.is(":checked");

				if (!salesFromPicker || (!salesToPicker && !durationIsSelected)) {
					//  date pickers not passed in
					args.IsValid = false;
					return;
				}

				var salesOnlyIsEnabled = $(".salesOnlyCheckBox input").is(":checked"),
					salesFromValue = salesFromPicker.val(),
					salesToValue = salesToPicker.val(),
					formulaName = $("#txtFormulaName").val(),
					isValid = true;

				switch (formulaName) {
					case "Sales Formula":
						if (
							((salesFromValue == "" || salesToValue == "") &&
								!durationIsSelected) ||
							(durationIsSelected && salesPeriodDurationValue.val() == "")
						) {
							//  date range selected and one or both datepickers empty OR
							//  duration selected and no duration value entered THEN
							//  show tooltip
							showSalesPeriodValidationTooltip(true);
							isValid = false;
						} else {
							showSalesPeriodValidationTooltip(false);
						}

						break;
					default:
						if (salesOnlyIsEnabled) {
							if (
								((salesFromValue == "" || salesToValue == "") &&
									!durationIsSelected) ||
								(durationIsSelected && salesPeriodDurationValue.val() == "")
							) {
								//  date range selected and one or both datepickers empty OR
								//  duration selected and no duration value entered THEN
								//  show tooltip
								showSalesPeriodValidationTooltip(true);
								isValid = false;
							} else {
								showSalesPeriodValidationTooltip(false);
							}
						}
						break;
				}

				args.IsValid = isValid;
			},
            validatePeriodPickers = function(s, args) {
				var fromPicker =
						BackOffice.options.periodDatePickerControlIds.fromDatePicker,
					toPicker =
						BackOffice.options.periodDatePickerControlIds.toDatePicker,
					periodDuration =
						BackOffice.options.periodDatePickerControlIds.periodDuration,
					periodDurationValue =
						BackOffice.options.periodDatePickerControlIds
							.periodDurationValue,
					durationIsSelected = periodDuration.is(":checked");

				if (!fromPicker || (!toPicker && !durationIsSelected)) {
					//  date pickers not passed in
					args.IsValid = false;
					return;
				}

				var fromValue = fromPicker.val(),
					toValue = toPicker.val(),
					isValid = true;
                
						if (
							((fromValue == "" || toValue == "") &&
								!durationIsSelected) ||
							(durationIsSelected && periodDurationValue.val() == "")
						) {
							//  date range selected and one or both datepickers empty OR
							//  duration selected and no duration value entered THEN
							//  show tooltip
                            showPeriodValidationTooltip(true);
							isValid = false;
						} else {
                            showPeriodValidationTooltip(false);
						}

				args.IsValid = isValid;
			},
            showPeriodValidationTooltip = function(makeVisible) {
                if (makeVisible) {
                    $(".periodPickers [data-toggle=tooltip]").tooltip("show");
                } else {
                    $(".periodPickers [data-toggle=tooltip]").tooltip("hide");
                }
            },
			showSalesPeriodValidationTooltip = function(makeVisible) {
				if (makeVisible) {
					$(".salesPeriodPickers [data-toggle=tooltip]").tooltip("show");
				} else {
					$(".salesPeriodPickers [data-toggle=tooltip]").tooltip("hide");
				}
			};

		return $.extend(backOffice.ScheduledReplenishment, {
			Init: initialise,
			ValidateSettingsForm: validateSettingsForm,
			ValidateWeeks: validateWeeks,
			ValidateSalesPeriodPicker: validateSalesPeriodPicker,
            ValidatePeriodPickers: validatePeriodPickers,
			ValidateLastDate: validateLastDate,
			ValidateFirstDate: validateFirstDate,
			ValidateScheduleTime: validateScheduleTime,
			ValidateScheduleForm: validateScheduleForm
		});
	})();

	return backOffice.ScheduledReplenishment;
})(BackOffice || {}, jQuery);
